import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=36118981&scoped=true"
import script from "./TextEllipsis.vue?vue&type=script&lang=js"
export * from "./TextEllipsis.vue?vue&type=script&lang=js"
import style0 from "./TextEllipsis.vue?vue&type=style&index=0&id=36118981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36118981",
  null
  
)

export default component.exports